import { useCallback } from "react";
import { toastManager } from "@salestrak/ui";
import { useTrashMutations } from "#app/hooks/settings/use-trash-mutations";
import { useIssueCardActions } from "./use-issue-card-actions";
import type { IssueActionRef } from "./use-issue-actions";

export function useDeleteIssueWithUndo() {
  const { deleteIssue } = useIssueCardActions();
  const { restoreItem } = useTrashMutations();

  return useCallback(
    async (issue: IssueActionRef) => {
      await deleteIssue(issue);
      // The one sanctioned neutral action toast: no `type`, so it renders
      // without a status icon, and the undo affordance is the toast action.
      toastManager.add({
        title: `"${issue.name}" moved to trash`,
        actionProps: {
          children: "Undo",
          onClick: () => {
            void restoreItem(issue.issueId, "Issue");
          },
        },
        timeout: 6000,
      });
    },
    [deleteIssue, restoreItem],
  );
}
